import React from 'react';

const CancelPage = () => (
  <div>
    <h1>Payment Canceled</h1>
    <p>Your payment was canceled. You may try again or contact support if you need assistance.</p>
  </div>
);

export default CancelPage;
